<template>
    <div id="app">
        <router-view />
        <!-- 页面内容在这里切换 -->
    </div>
</template>

<script>
export default {
    name: "App",
    components: {},
    created() {
        this.enterEventInit();
    },
    mounted() {
        // 当app.vue挂载完毕时，让浏览器延迟1s自动删除class为.loading-screen的这个节点（有点绕，但可以好好想想）
        const avueHome = document.querySelector(".loading-screen"); // 获取到这个class的节点
        this.$nextTick(() => {
            avueHome && avueHome.parentNode && avueHome.parentNode.removeChild(avueHome); // 该节点的父级去删除这个class
        });
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000;
}
html,
body {
    color: #000;
}
</style>
